"use client";

import { useEffect } from "react";

import { THEME_STORAGE_KEY, applyDocumentThemePreference } from "@/lib/documentTheme";

/** Keeps `data-ed-theme` in sync when the preference changes in another tab. */
export function DocumentThemeSync() {
  useEffect(() => {
    function onStorage(ev: StorageEvent) {
      if (ev.key !== THEME_STORAGE_KEY || ev.newValue == null) return;
      if (ev.newValue === "dark" || ev.newValue === "light") {
        applyDocumentThemePreference(ev.newValue === "dark");
      }
    }
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return null;
}
